/**
 * Card Title Styling Constants
 * Material Design 3 Standard for Command & Control Dashboard
 * 
 * These styles ensure consistent card header typography across the entire application.
 * All card titles must use these exact specifications per design guidelines.
 */

import { SxProps, Theme } from '@mui/material';

/**
 * Standard Card Title Style
 * - Color: #ff8555 (Headings color from Guidelines.md)
 * - Font: Roboto 16px Regular (400 weight)
 * - Text truncation enabled with ellipsis
 */
export const CARD_TITLE_STYLE: SxProps<Theme> = {
  fontFamily: 'Roboto, sans-serif',
  fontSize: '16px',
  fontWeight: 400,
  color: '#ff8555',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
} as const;

/**
 * Card Title Spacing Standards (Material Design 3 8px grid)
 * Use these margin-bottom values based on what follows the title
 */
export const CARD_TITLE_SPACING = {
  /** Title followed by subtitle or metadata (4px) */
  WITH_SUBTITLE: 0.5,
  
  /** Title followed by search field or controls (8px) */
  WITH_CONTROLS: 1,
  
  /** Title followed by main content/table (16px) */
  WITH_CONTENT: 2,
} as const;

/**
 * Card Title with Tooltip (for truncated text accessibility)
 * Wraps Typography in Tooltip to show full text on hover
 */
export const getCardTitleWithTooltip = (title: string, additionalSx?: SxProps<Theme>) => ({
  title,
  sx: {
    ...CARD_TITLE_STYLE,
    ...additionalSx,
  },
});
